import { useEffect } from 'react';
import { useRouter } from 'next/router';
import {
  getStaticExportRedirectPath,
  getStaticExportRedirectTarget,
  isAppRoutePath
} from '@/libs/staticExportRedirect';

export const useStaticExportRedirect = (enabled = true) => {
  const { isReady, query, replace } = useRouter();
  const redirectPath = getStaticExportRedirectPath(query.path);
  const isRedirecting = enabled && isReady && !!redirectPath;

  useEffect(() => {
    if (!isRedirecting || !redirectPath) return;

    replace(getStaticExportRedirectTarget(redirectPath)).catch((error) => {
      console.error('Static export redirect failed', error);
    });
  }, [isRedirecting, redirectPath, replace]);

  useEffect(
    () => () => {
      document.documentElement.removeAttribute('data-static-app-route');
    },
    []
  );

  return {
    isAppRedirect: isAppRoutePath(redirectPath),
    isRedirecting,
    redirectPath
  };
};
